import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicGuard, LayoutGuard } from './guards';
import { APP_ROUTES_CONSTANTS } from './constants/routes.constants';
import { CONTENT_MANAGEMENT_CONSTANTS } from './constants/app.constants';


const routes: Routes = [
  {
    path: '',
    redirectTo: APP_ROUTES_CONSTANTS.PUBLIC_ROUTE.path,
    pathMatch: 'full'
    // loadChildren: () => import('./modules/homepage/homepage.module').then(m => m.HomepageModule),
    // canActivate: [PublicGuard],
     //canLoad: [PublicGuard],
  },
  {
    path: APP_ROUTES_CONSTANTS.PUBLIC_ROUTE.path,
    // path: '',
    loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule),
    canActivate: [PublicGuard],
    //canLoad: [PublicGuard],
  },
  {
    path: APP_ROUTES_CONSTANTS.LAYOUT_ROUTE.path,
    loadChildren: () => import('./modules/layouts/layouts.module').then(m => m.LayoutsModule),
    canActivate: [LayoutGuard],
    canLoad: [LayoutGuard]
  },
  {
    path: APP_ROUTES_CONSTANTS.BACKEND_VERIFICATION_TEMPLATE_ROUTE.path,
    loadChildren: () => import('./modules/backend-verification-template/backend-verification-template.module').then(m => m.BackendVerificationTemplateModule)
  },
  {
    path: APP_ROUTES_CONSTANTS.CONTACT_US_ROUTE.path,
    loadChildren: () => import('./modules/contact-us/contact-us-wrapper.module').then(m => m.ContactUsWrapperModule)
  },
  {
    path: APP_ROUTES_CONSTANTS.PRIVACY_POLICIES_ROUTE.path,
    loadChildren: () => import('./modules/content-managements/content-managements.module').then(m => m.ContentManagementsModule),
    data: { type: CONTENT_MANAGEMENT_CONSTANTS.PRIVACY_POLICY }
  },
  {
    path: APP_ROUTES_CONSTANTS.TERM_AND_CONDITION_ROUTE.path,
    loadChildren: () => import('./modules/content-managements/content-managements.module').then(m => m.ContentManagementsModule),
    data: { type: CONTENT_MANAGEMENT_CONSTANTS.TERM_AND_CONDITION }
  },
  {
    path: APP_ROUTES_CONSTANTS.ABOUT_US_ROUTE.path,
    loadChildren: () => import('./modules/content-managements/content-managements.module').then(m => m.ContentManagementsModule),
    data: { type: CONTENT_MANAGEMENT_CONSTANTS.ABOUT_US }
  },
  {
    path: 'invite',
    loadChildren: () => import('./modules/accounts/pages/invite-landing/invite-landing.module').then(m => m.InviteLandingModule),
    canActivate: [PublicGuard]
  },
  { path: '**', loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
    initialNavigation: 'enabled',
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
